import { render, staticRenderFns } from "./MiddlePopup.vue?vue&type=template&id=bc8e232e&lang=html"
import script from "./MiddlePopup.vue?vue&type=script&lang=js"
export * from "./MiddlePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports